<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-shij`]" width="1em" height="1em" v-bind="$attrs"><g :fill="useCurrentColor ? 'currentColor' : '#4E5969'" fill-rule="nonzero"><path d="M57,114 C36.635862,114 17.8186216,103.135862 7.63655213,85.5 C-2.54551738,67.8641387 -2.54551738,46.1358613 7.63655213,28.5 C17.8186216,10.8641383 36.635862,0 57,0 C88.4802313,0 114,25.5197696 114,57 C114,88.4802304 88.4802313,114 57,114 L57,114 Z M57.0000008,101.333333 C81.4846248,101.333333 101.333334,81.4846239 101.333334,57 C101.333334,32.5153761 81.4846248,12.6666666 57.0000008,12.6666666 C32.5153769,12.6666666 12.6666675,32.5153761 12.6666675,57 C12.6666675,81.4846239 32.5153769,101.333333 57.0000008,101.333333 Z" transform="translate(8 8)"/><path d="M63.7744 53.78L83 65.5342857 75.9152 76 51 60.5057144 51 32 63.7744 32z" transform="translate(8 8)"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmShij',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
